import { formatCzkShort } from '@fire-calc/ui-vue';

export function strategyFormatCzkShort(value: number): string {
  return formatCzkShort(value);
}
